import React, { Component } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { fetchTradeOffers } from '../../../../actions/tradeOffersActions';
import { connect } from 'react-redux';
import CheckIfAnyData from '../../../shared/CheckIfAnyData';
import Spinner from '../../../shared/_Spinner';
import { isMobile } from '../../../../lib/responsive';
import TradeOffersReceivedMobile from '../accepted/TradeOffersReceivedMobile';
import TradeOffersReceivedDesktop from '../accepted/TradeOffersReceivedDesktop';
import TradeOffersRequestedMobile from '../accepted/TradeOffersRequestedMobile';
import TradeOffersRequestedDesktop from '../accepted/TradeOffersRequestedDesktop';

class Accepted extends Component {
    _renderReceivedTrades = () => {
      const { tradeOffersReceived, loading } = this.props;
      const TradeOffersReceived = isMobile ? TradeOffersReceivedMobile : TradeOffersReceivedDesktop;

      return (
        <React.Fragment>
          <div className={ 'trade-post__title' }>Received</div>
          { !isMobile && (
            <div className='trade-post__header'>
              <div className='trade-post__header-item trade-post__office'>Office</div>
              <div className='trade-post__header-item trade-post__requester'>Requester</div>
              <div className='trade-post__header-item trade-post__offered-appt'>Offered Appt</div>
              <div className='trade-post__header-item trade-post__requested-appt'>Requested Appt</div>
              <div className='trade-post__header-item trade-post__status'>Status</div>
            </div>
          )}
          <Spinner enabled={ loading }>
            <CheckIfAnyData dataSize={ tradeOffersReceived.size } message={'There are no trade offers'}>
              <TradeOffersReceived tradeOffersReceived={ tradeOffersReceived } />
            </CheckIfAnyData>
          </Spinner>
        </React.Fragment>
      );
    };

    _renderRequestedTrades = () => {
      const { tradeOffersRequested, loading } = this.props;
      const TradeOffersRequested = isMobile ? TradeOffersRequestedMobile : TradeOffersRequestedDesktop;

      return (
        <React.Fragment>
          <div className={ 'trade-post__title' }>Requested</div>
          { !isMobile && (
            <div className='trade-post__header'>
              <div className='trade-post__header-item trade-post__office'>Office</div>
              <div className='trade-post__header-item trade-post__receiver'>Receiver</div>
              <div className='trade-post__header-item trade-post__offered-appt'>Offered Appt</div>
              <div className='trade-post__header-item trade-post__requested-appt'>Requested Appt</div>
              <div className='trade-post__header-item trade-post__status'>Status</div>
            </div>
          )}
          <Spinner enabled={ loading }>
            <CheckIfAnyData dataSize={ tradeOffersRequested.size } message={'There are no trade offers'}>
              <TradeOffersRequested tradeOffersRequested={ tradeOffersRequested } />
            </CheckIfAnyData>
          </Spinner>
        </React.Fragment>);
    };

    componentDidMount() {
      const { tradeOffersFetch } = this.props;

      tradeOffersFetch({ status: 'accepted' });
    }

    render() {
      return (
        <div className='trade-post'>
          {this._renderReceivedTrades()}
          {this._renderRequestedTrades()}
        </div>

      );
    }
}

Accepted.propTypes = {
  loading: PropTypes.bool,
  tradeOffersFetch: PropTypes.func.isRequired,
  tradeOffersReceived: PropTypes.instanceOf(Immutable.Map).isRequired,
  tradeOffersRequested: PropTypes.instanceOf(Immutable.Map).isRequired
};

const mapStateToProps = (state) => ({
  tradeOffersReceived: state.getIn(['tradeOffers', 'data', 'receivedTrades'], Immutable.Map()),
  tradeOffersRequested: state.getIn(['tradeOffers', 'data', 'requestedTrades'], Immutable.Map()),
  loading: state.getIn(['tradeOffers', 'loading'])
});

const mapDispatchToProps = (dispatch) => ({
  tradeOffersFetch: (params) => dispatch(fetchTradeOffers(params))
});

export default connect(mapStateToProps, mapDispatchToProps)(Accepted);



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/accepted/Accepted.jsx